import React from 'react'
const Moviename = props => {
  // props for this file from parent
  const { movieID, modeUrl, editData, active, inputData } = props
  // function for change the moviename on change and send to parent
  const movieName = event => {
    props.sendtruevalue('moviename', true)
    props.sendmoviename('movieName', event.target.value)
    // console.log(event.target.value, 'moviename======')
  }

  const indication = modeUrl
    ? editData.movieName === movieID || active.movieName === 'TRUE'
      ? { borderColor: 'green' }
      : { borderColor: 'red' }
    : ''
  return (
    <div>
      <div className='shotbio'>
        <label>
          {inputData.contentType === 'movies' ? 'Movie' : 'Webseries'}Name_En:
          <div className='mandatory'>*</div>
        </label>
        <input
          className='form-control'
          type='text'
          placeholder={`please enter ${
            inputData.contentType === 'movies' ? 'movie' : 'webseries'
          } name`}
          value={movieID}
          onChange={event => movieName(event)}
          style={modeUrl && indication}
        />
      </div>
      {movieID.length < 1 && <span className='mandatory1 '>movie name should not be empty </span>}
    </div>
  )
}

export default Moviename
